module.exports = __webpack_public_path__ + "f31bb8d21d203b9aee46166c313c66fb.png";